import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imgBlob',
  standalone: true,
})
export class ImgBlobPipe implements PipeTransform {
  transform(blob: Blob): string {
    return URL.createObjectURL(blob);
  }
}
